import * as React from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Hidden,
} from "@material-ui/core";
import {DialogProps} from "@material-ui/core/Dialog";
import {makeStyles} from "@material-ui/core/styles";
import {themeVariables} from "../_Theme";
import {SvgIcon} from "../../../../components";
import {tl} from "../../../../utils";
import * as styles from "./styles.scss";
import {Close} from "@material-ui/icons";

interface IProps extends DialogProps {
  title?: any;
  notitle?: boolean;
  headerWhite?: boolean;
  actions?: any[];
  actionsInline?: boolean;
  centered?: boolean;
  actionsCentered?: boolean;
  notFullWidth?: boolean;
  mobileFullScreen?: boolean;
  mobileFullWidth?: boolean;
  withControls?: boolean;
  noclose?: boolean;
  closeIconSmall?: boolean;
  pInner?: number;
  dialogContentClassName?: string;
  closeOutside?: boolean;
}

export const MUIDialog = ({
  title,
  notitle,
  headerWhite,
  actions,
  actionsInline,
  centered,
  actionsCentered,
  notFullWidth,
  mobileFullScreen,
  mobileFullWidth,
  closeIconSmall,
  withControls,
  pInner,
  noclose,
  closeOutside,
  dialogContentClassName,
  ...dialogProps
}: IProps) => {
  const classes = makeStyles({
    Dialog: {
      height: "100%",
      borderWidth: 1,
      borderStyle: "solid",
      boxShadow: "none",
      borderColor: themeVariables.palette.borderOuter,
    },
    noWrap: {
      [themeVariables.breakpoints.up("sm")]: {
        flexWrap: "nowrap",
      },
    },
    pInner: {
      padding: `${pInner * themeVariables.spacing}px !important`,
    },
    title: {
      "& > .MuiTypography-h6": {
        fontSize: 15,
        lineHeight: "22px",
        fontWeight: 600,
        letterSpacing: "0.3px",
      },
    },
  })({});

  return (
    <Dialog
      fullWidth={!notFullWidth}
      disableEnforceFocus={true}
      maxWidth={notFullWidth ? null : "xs"}
      {...dialogProps}
      className={`${mobileFullScreen ? "mobileFullScreen" : ""} ${
        mobileFullWidth ? "mobileFullWidth" : ""
      } ${withControls ? "withControls" : ""} ${dialogProps.className}`}
    >
      {closeOutside && 
        <Close onClick={() => dialogProps.onClose({}, 'backdropClick')}  style={{height: 24, fontSize: 24, color: '#fff', cursor: 'pointer', position: 'fixed', right: 50, top: 50}} />
      }
      {notitle ? null : (
        <DialogTitle
          className={`${dialogProps.onClose ? styles.closable : ""} ${
            classes.title
          }`}
        >
          {title ? title : tl("Внимание!")}
          {dialogProps.onClose && !noclose ? (
            <Box
              className={styles.closableTrigger}
              onClick={(evt: any) => {
                dialogProps.onClose({}, "backdropClick");
              }}
            >
              <SvgIcon type={`dialog-close ${closeIconSmall ? "small" : ""}`} />
              {/* <Close style={{height: 16, fontSize: 16, color: '#9da1a5'}} /> */}
            </Box>
          ) : null}
        </DialogTitle>
      )}
      <DialogContent
        className={`${dialogContentClassName} ${
          centered ? styles.centered : null
        } ${pInner === undefined ? "" : classes.pInner}`}
      >
        {dialogProps.children}
      </DialogContent>
      {actions ? (
        <DialogActions>
          <Grid
            container
            justifyContent="space-between"
            alignItems="center"
            spacing={withControls ? 2 : undefined}
          >
            {actions.map(
              (actionsGroup: any, i: number) =>
                actions && (
                  <Grid
                    item
                    key={`dialog-actionsGroups-${i}`}
                    xs={withControls ? 6 : 12}
                    sm={actionsCentered ? true : "auto"}
                  >
                    <Grid
                      container
                      spacing={1}
                      alignItems="center"
                      className={classes.noWrap}
                      justifyContent={
                        actionsInline ? "space-between" : "flex-start"
                      }
                    >
                      {actionsGroup.map((action: any, idx: number) =>
                        action && withControls && action["$$typeof"] ? (
                          <Hidden
                            only="xs"
                            key={`dialog-actions-${action.label}-${idx}`}
                          >
                            <Grid
                              item
                              xs={12}
                              sm={actionsCentered ? true : "auto"}
                            >
                              <Box clone>{action}</Box>
                            </Grid>
                          </Hidden>
                        ) : (
                          <Grid
                            item
                            key={`dialog-actions-${action.label}-${idx}`}
                            xs={actionsInline ? "auto" : 12}
                            sm={actionsCentered ? true : "auto"}
                          >
                            {action["$$typeof"] ? (
                              <Box clone>{action}</Box>
                            ) : (
                              <Button variant={action.btnProps?.variant || 'contained'} {...action.btnProps}>
                                {action.label ? action.label : tl("Ок")}
                              </Button>
                            )}
                          </Grid>
                        )
                      )}
                    </Grid>
                  </Grid>
                )
            )}
          </Grid>
        </DialogActions>
      ) : null}
      {notitle && dialogProps.onClose && !noclose ? (
        <Box
          className={`${styles.closableTrigger} ${styles.mobileonly}`}
          onClick={(evt: any) => {
            dialogProps.onClose({}, "backdropClick");
          }}
        >
          <SvgIcon type={`dialog-close ${closeIconSmall ? "small" : ""}`} />
        </Box>
      ) : null}
    </Dialog>
  );
};
